import React, { useEffect, useRef, useState } from 'react'
import api, { getCategoryPosts } from '../../../../../utils/api'
import HorizontalScroll from '../../../../../components/HorizontalScroll'
import { WP_REST_API_Post } from 'wp-types/index'
import PostSummary from '../../../../../partials/Post/PostSummary'
import { Color } from '../../../../../utils/constants'
import ArrowNavigation from '../../../../../components/ArrowNavigation'
import DownloadLink from './DownloadLink'
import DetailsForm from './DetailsForm'
import CK from 'js-cookie'
import { twMerge } from 'tailwind-merge'
import { getCategoryAndTags } from '../../../../../partials/Post/utils'
import { CategoryType } from '../../../../../components/Category'

const ApplicationNotes = () => {
    const [formSubmitted, setFormSubmitted] = useState(false)

    // const [categories, setCategories] = useState<any[]>([])
    const [posts, setPosts] = useState<WP_REST_API_Post[]>([])
    const [openPost, setOpenPost] = useState<WP_REST_API_Post | null>(null)

    useEffect(() => {
    // getResourceCategories(setCategories)
        api.get('/wp-json/wp/v2/categories').then(({ data }) => {
            const applicationSegmentsCategory = data.find(
                (category: { slug: string }) => category.slug === 'application-segments',
            )
            if (applicationSegmentsCategory) {
                getCategoryPosts(setPosts, [applicationSegmentsCategory])
            }
        })
    }, [])

    useEffect(() => {
        const email = CK.get('application_note')
        setFormSubmitted(!!email)
    }, [openPost])

    // useEffect(() => {
    //     if (categories.length > 0) {
    //         getCategoryPosts(
    //             setPosts,
    //             categories.filter((cat) =>
    //                 [CategoryType.APPLICATION_NOTE, CategoryType.CASE_STUDY].includes(cat.slug),
    //             ),
    //         )
    //     }
    // }, [categories])

    const scrollRef = useRef<HTMLDivElement>(null)

    if (posts.length === 0) return <></>

    return (
        <div className='md:py-24 pb-10 relative'>
            <ArrowNavigation
                scrollRef={scrollRef}
                buttonColor={Color.BLACK}
                className={twMerge(
                    'hidden absolute first:translate-x-[-120%] last:right-0 last:translate-x-[120%]',
                    posts.length > 3 && 'md:block',
                )}
            >
                <div className='w-full'>
                    <HorizontalScroll wrapperClasses='py-12 gap-x-10 ' ref={scrollRef}>
                        {posts.map((post: WP_REST_API_Post) => {
                            const { category } = getCategoryAndTags(post)
                            const shouldRedirectToResources = ![
                                CategoryType.APPLICATION_NOTE,
                                CategoryType.CASE_STUDY,
                            ].includes(category)
                            const onClick =
                formSubmitted || shouldRedirectToResources ? undefined : () => setOpenPost(post)
                            return (
                                <PostSummary
                                    post={post}
                                    key={`post-${post.id}`}
                                    className='md:w-[31%]'
                                    color={Color.BLACK}
                                    ActionButton={
                                        shouldRedirectToResources ? undefined : <DownloadLink open={onClick} />
                                    }
                                    onClick={onClick}
                                />
                            )
                        })}
                    </HorizontalScroll>
                </div>
            </ArrowNavigation>
            {openPost && <DetailsForm close={() => setOpenPost(null)} post={openPost} />}
        </div>
    )
}

export default ApplicationNotes
